module.exports = __webpack_public_path__ + "static/media/YM17_6.eb8c03f6.jpg";